import { render, staticRenderFns } from "./Employers.vue?vue&type=template&id=5c8b4a4b&"
import script from "./Employers.vue?vue&type=script&lang=js&"
export * from "./Employers.vue?vue&type=script&lang=js&"
import style0 from "./Employers.vue?vue&type=style&index=0&id=5c8b4a4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports